<template>
  <v-container
    fluid
    style="width: 100%; height: 100%"
  >
    <v-row
    >
      <v-col
        cols="12"
      >
        <v-progress-linear
          v-if="!isConnected"
          color="primary"
          indeterminate
          striped
          height="10"
          rounded
        ></v-progress-linear>

        <div
          id="view"
          v-resize="resize"
          :style="'height: ' + columnHeight + 'px;'"
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import RFB from '@novnc/novnc/lib/rfb'

export default {
  name: "novnc-window",
  props: ["host", "port", "password"],
  data () {
    return {
      //ip: 'ws://10.30.2.22:5904',
      rfb: null,
      isConnected: false,
      //https://github.com/novnc/noVNC/blob/master/docs/API.md
      resize_width: 99999,
      resize_height: 99999,
    }
  },
  computed: {
    ip(){
      return "ws://" + this.host + ":" + this.port
    },
    columnHeight(){
      return (this.rfb == null) ? 10 : this.$vuetify.breakpoint.height - 85
    }
  },
  methods: {
    sendCtrlAltDel(){
      this.rfb.sendCtrlAltDel()
    },
    resize(){
      if(this.resize_width < window.outerWidth && this.resize_height < window.outerHeight){
        this.connect()
      }
      this.resize_width = window.outerWidth
      this.resize_height = window.outerHeight
    },
    connect(){
      this.rfb = new RFB(document.getElementById('view'), this.ip , { credentials: { password: this.password }});

      this.rfb.addEventListener('connect', () => {
        this.isConnected = true
      });
      this.rfb.addEventListener('disconnect', () => {
        this.isConnected = false
      });
      this.rfb.scaleViewport = true;
      this.rfb.clipViewport = true;
      this.rfb.resizeSession = true;
    },
    disconnect() {
      this.rfb.disconnect();
      this.connect()
    }
  },
  mounted() {
    this.connect()
  },
  destroyed() {
    console.log("Destroyed " + this.ip)
  }
};
</script>

<style scoped>

</style>
